import React, { useState, useEffect } from "react"

const Timers = ({
  delayResend = "300",
  setDelayTrigger,
  delayTrigger,
  setResendEnable,
  staticTexts
}) => {
  const [delay, setDelay] = useState(+delayResend)
  const minutes = Math.floor(delay / 60)
  const seconds = Math.floor(delay % 60)

  useEffect(() => {
    if (delayTrigger) {
      setDelay(+delayResend)
      setDelayTrigger(false)
    }
  }, [delayTrigger])

  useEffect(() => {
    const timer = setInterval(() => {
      setDelay(delay - 1)
    }, 1000)

    if (delay === 0) {
      clearInterval(timer)
      setDelayTrigger(false)
      setResendEnable(true)
    }

    return () => {
      clearInterval(timer)
    }
  }, [delay])

  return (
    <>
      <span className="expireotp">{staticTexts?.otpexpire}</span>
      <span className="auth-otp-modal__timer">
        {minutes >= 10 ? minutes : `0${minutes}`}:
        {seconds >= 10 ? seconds : `0${seconds}`}
      </span>
    </>
  )
}

export default Timers
